import { render, staticRenderFns } from "./LinearStatistic.vue?vue&type=template&id=8cc28062&"
import script from "./LinearStatistic.vue?vue&type=script&lang=js&"
export * from "./LinearStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports